import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app.tsx';
import { Provider } from "react-redux";
import store from "./store";
import reportWebVitals from './report-web-vitals';
import { UserProvider } from './user-context';

import { MsalProvider } from "@azure/msal-react";
import { AZURE_AUTH_CONFIG } from './services/auth/constants';
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: AZURE_AUTH_CONFIG.clientId || "",
        authority: AZURE_AUTH_CONFIG.authority || undefined,
        redirectUri: AZURE_AUTH_CONFIG.redirectUri || undefined,
    },
    cache: {
        cacheLocation: "sessionStorage",
    },
    system: {
      allowNativeBroker: false,
      windowHashTimeout: 9000,
      iframeHashTimeout: 9000,
      loadFrameTimeout: 9000,
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      sessionStorage.setItem("msalAccessToken", response.accessToken);
    }
  }).catch(() => {
    // Handle errors if needed
  }).finally(() => {
    // Only render the app AFTER MSAL is done processing
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <UserProvider>
            <App />
          </UserProvider>
        </Provider>
      </MsalProvider>
      </React.StrictMode>
    );
  });
});

reportWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
